import { useRef } from 'react';
import { cn } from '../../lib/utils';
import { fieldWrapper, fieldWrapperInput } from './field-surface';

interface CurrencyInputProps extends Omit<React.ComponentProps<'input'>, 'type'> {
	currency: string;
}

export function CurrencyInput({ className, currency, ...props }: CurrencyInputProps) {
	const ref = useRef<HTMLInputElement>(null);

	return (
		<div className={cn(fieldWrapper, className)}>
			<input
				ref={ref}
				type="number"
				data-slot="input"
				className={cn(
					fieldWrapperInput,
					'[&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none'
				)}
				{...props}
			/>
			<div className="flex shrink-0 items-center border-l border-line-2 bg-surface-fill px-2.5 text-xs font-medium text-text-3">
				{currency}
			</div>
		</div>
	);
}
